/* eslint-disable no-param-reassign */
import jwtDecode from 'jwt-decode';
import axios from '../utils/axios';
import {
  postLogin, getUserById,
} from '../requests/api/auth';
import { UNKNOWN_ERROR } from '../constants/errors';

const getAccessToken = () => localStorage.getItem('accessToken');

const setSession = (accessToken, sessionId = null) => {
  let id = null;
  if (accessToken) {
    const { user = {} } = jwtDecode(accessToken) || {};
    if (user?.id) id = user.id;
  }
  if (id) {
    localStorage.setItem('accessToken', accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    const { id = '' } = jwtDecode(accessToken)?.user || {};
    localStorage.setItem('userId', id);
    if (sessionId) {
      localStorage.setItem('sessionId', sessionId);
    }
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userId');
    localStorage.removeItem('sessionId');
    delete axios.defaults.headers.common.Authorization;
  }
};

const setAxiosInterceptors = ({ onLogout }) => {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        if (onLogout) {
          setSession(null);
          onLogout();
        }
      }

      return Promise.reject(error);
    },
  );
};

const loginWithEmailAndPassword = async (email, password) => {
  try {
    const response = await postLogin({
      email,
      password,
    });
    let accessToken;
    let sessionId = null;

    if (response.data.user) {
      ({ accessToken } = response.data);
      if (response.data.sessionId) {
        sessionId = response.data.sessionId;
      }
      setSession(accessToken, sessionId);
      return response;
    }
    setSession(null);
    return response;
  } catch (err) {
    setSession(null);
    return {
      success: false,
      message: UNKNOWN_ERROR,
      data: {},
    };
  }
};

const logoutSession = () => {
  setSession(null);
};

const getSessionId = () => localStorage.getItem('sessionId');

const setSessionId = (sessionId) => {
  if (sessionId) {
    localStorage.setItem('sessionId', sessionId);
  } else {
    localStorage.removeItem('sessionId');
  }
};

const loginInWithToken = async () => {
  const accessToken = getAccessToken();
  const { id = '' } = jwtDecode(accessToken)?.user || {};
  try {
    const response = await getUserById(id);
    if (!response.success) {
      logoutSession();
      return null;
    }
    return (response.data) || null;
  } catch (err) {
    return null;
  }
};

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

const handleAuthentication = () => {
  const accessToken = getAccessToken();

  if (!accessToken) {
    setSession(null);
    return;
  }

  if (isValidToken(accessToken)) {
    setSession(accessToken);
  } else {
    setSession(null);
  }
};

const isAuthenticated = () => !!getAccessToken();

export default {
  setAxiosInterceptors,
  loginWithEmailAndPassword,
  loginInWithToken,
  logoutSession,
  handleAuthentication,
  isAuthenticated,
  setSession,
  getSessionId,
  setSessionId,
};
